import { DateRangePickerInput } from '@sequencehq/core-components'
import { useSelectedDateRange } from 'RevenueRecognition/view/utils/useSelectedDateRange'

export const RevRecDashboardDateFilter = ({
  defaultDateRange
}: {
  defaultDateRange?: [Date, Date]
} = {}) => {
  const { dateRange, setDateRange } = useSelectedDateRange({ defaultDateRange })

  return <DateRangePickerInput value={dateRange} onChange={setDateRange} />
}
